import EntityNotificationsListing from './EntityNotificationsListing';

export default EntityNotificationsListing;
